import React, { useState, useEffect, useRef } from "react";
import Header from "./components/Header";
import { Footer } from "./components/Footer";
import { Contactform } from "./components/Contactform";
import Slider from "react-slick";
import img02 from "./images/dualband.webp";
import { Accordion, AccordionItem } from "react-light-accordion";
import axios from "axios";

export const Dualband = () => {
  var decodeHTML = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  function createMarkup(content) {
    return { __html: decodeHTML(content) };
  }

  const [pagedata, setPagedata] = useState([]);
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      const response = await axios.get(window.weburl + `api/plans.php?catID=7`);
      if (mounted) {
        setPagedata(response.data);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  console.log(pagedata);
  if (pagedata.length === 0) {
    console.log("no data");
  }

  const [user_mobile, setusermobile] = useState();
  const [plans, setPlans] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const ref_mobile = useRef(null);

  const [selectedPlan, setSelectedPlan] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_plans.php?cid=14")
      .then((response) => setPlans(response.data))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_states.php")
      .then((response) => setStates(response.data))
      .catch((error) => console.log(error));
  }, []);

  function getCities(state) {
    axios
      .get(window.weburl + `api/get_cities.php?sid=${state}`)
      .then((response) => setCities(response.data))
      .catch((error) => console.log(error));
  }

  const handledisable = () => {
    if (isValidPhone(user_mobile) && user_mobile) {
      const element = document.getElementById("submit_button_text");
      element.classList.remove("disabled");
      setIsDisabled(false);
    } else {
      const element = document.getElementById("submit_button_text");
      element.classList.add("disabled");
      setIsDisabled(true);
    }
  };

  function isValidPhone(phone) {
    const regex = /^[6-9]\d{9}$/gi;
    return regex.test(phone);
  }

  const handleSubmit = () => {
    if (!isValidPhone(user_mobile)) {
      alert("Please enter Mobile number");
      ref_mobile.current.focus();
      return false;
    } else {
      const url = window.weburl + "api/insert_hook.php";
      let fData = new FormData();
      fData.append("user_mobile", user_mobile);
      fData.append("catid", "7");
      fData.append("pid", selectedPlan);
      fData.append("user_state", selectedState);
      fData.append("user_city", selectedCity);
      fData.append("td_name", "androidtv");
      fData.append("utm_url", window.location.href);
      axios
        .post(url, fData)
        .then((response) => {
          // ⭐⭐⭐ ADD GOOGLE ADS CONVERSION TAG HERE
          if (window.gtag) {
            window.gtag("event", "conversion", {
              // send_to: "AW-801924308/pEhpCICE9_4CENTJsf4C",
              send_to: "AW-801924308/HeMjCImtpfIbENTJsf4C", 
            });
          }
          // ⭐⭐⭐ END ADD

          alert(response.data);
        })
        .catch((error) => alert(error));
      window.location.reload();
    }
  };

  var settings = {
    dots: true,
    navigation: true,
    loop: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    speed: 300,
    autoplaySpeed: 5000,
    arrows: false,
    cssEase: "linear",
  };
  return (
    <>
      <Header />
      <section
        id="banner"
        className="p-0"
        data-aos="fade-left"
        data-aos-offset="200"
        data-aos-duration="600"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
        <div className="banner mngslide">
          <div className="container">
            <div className="row">
              <Slider {...settings}>
                <div>
                  <div className="sliderrow">
                    <div className="slideimg">
                      <img src={img02} alt="Banner Netplus" />
                    </div>
                    <div className="slidecont">
                      <div className="circle01">
                        <div className="mngcircle">
                          <div className="circlimg">
                            <h2>Netplus Dual-band FTTH Router</h2>
                          </div>
                          <div className="listpoint">
                            <p>
                              Optical terminal unit with 1 GE Port + 3 FE Port
                              +2.4G&5G Dual Band Wifi+ 1POTS + 1USB ports.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="circle02"></div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section id="filter">
        <div className="filter">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="footerform"
                  data-aos="fade-up"
                  data-aos-offset="10"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <div className="heading">
                    <h4>Get it today</h4>
                  </div>
                  <div className="form">
                    <form>
                      <ul>
                        <li>
                          <input
                            type="text"
                            name="user_mobile"
                            id="user_mobile"
                            placeholder="Mobile number*"
                            pattern="[a-zA-Z\s]+"
                            value={user_mobile}
                            onChange={(e) => {
                              setusermobile(e.target.value);
                            }}
                            onKeyUp={handledisable}
                            ref={ref_mobile}
                          />
                        </li>
                        <li>
                          <select
                            name="selectedPlan"
                            id="selectedPlan"
                            value={selectedPlan}
                            onChange={(event) => {
                              setSelectedPlan(event.target.value);
                            }}
                          >
                            <option value="">Select Product</option>
                            {plans.map((plan) => (
                              <option
                                key={plan.sno}
                                value={plan.sno}
                                dangerouslySetInnerHTML={createMarkup(
                                  plan.pname + " " + plan.ptitle,
                                )}
                              ></option>
                            ))}
                          </select>
                        </li>
                        <li>
                          <select
                            name="selectedState"
                            id="selectedState"
                            value={selectedState}
                            onChange={(event) => {
                              setSelectedState(event.target.value);
                              getCities(event.target.value);
                            }}
                          >
                            <option value="">Select Region</option>
                            {states.map((state) => (
                              <option key={state.stateid} value={state.stateid}>
                                {state.sname}
                              </option>
                            ))}
                          </select>
                        </li>
                        <li>
                          <select
                            name="selectedCity"
                            id="selectedCity"
                            value={selectedCity}
                            onChange={(event) =>
                              setSelectedCity(event.target.value)
                            }
                          >
                            <option value="">Select City</option>
                            {cities.map((city) => (
                              <option key={city.cityid} value={city.cityid}>
                                {city.cityname}
                              </option>
                            ))}
                          </select>
                        </li>
                        <li className="buttnprop">
                          <input
                            type="submit"
                            value=""
                            id="submit_button"
                            disabled={isDisabled}
                            onClick={handleSubmit}
                          />
                          <span id="submit_button_text" className="disabled">
                            SUBMIT
                          </span>
                        </li>
                      </ul>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="enterprise">
        <div className="enterprise">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <span>Dual-band FTTH Router</span>
                </div>
                <div
                  className="smartcont"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <p>
                    Optical terminal unit with 1 GE Port + 3 FE Port +2.4G&5G
                    Dual Band Wifi+ 1POTS + 1USB ports.
                  </p>
                  <p>
                    FTTH is a dual band Gigabit Premium triple-play GPON
                    gateway. It comes with 1GE&3FE LAN ports, one phone port and
                    next generation multi-stream Wi-Fi, operating simultaneously
                    in 2.4GHz 2×2 over 802.11n and 5GHz 2×2 over 802.11ac. The
                    maximum 5dBi gain antennas can enhance the Wi-Fi coverage
                    area and improve the performance.
                  </p>
                  <h5>Highly Reliable Feature</h5>
                  <p>
                    Dual-Band concurrent Wi-Fi mode so that its Wi-Fi speed can
                    reach up to 1.2Gbps, consisting of 300Mbps (802.11n 2×2 @
                    2.4GHz) and 866Mbps (802.11ac 2×2 @5GHz). The dual image
                    ensures uninterrupted services during software download or
                    upgrade, thereby enhancing software reliability. The highly
                    reliable lightning protection design provides lightning and
                    surge protection of 4 kV for the adapter, 1.5 kV for the
                    POTS port, and 1.5 kV for the Ethernet ports.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="specification">
        <div className="specification">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="heading"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h4>
                    The Netplus wireless Wi-Fi extender
                    <br /> meets the following EIRP standard:
                  </h4>
                </div>
                <div
                  className="faqcont"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <table class="table table-striped">
                    <tbody>
                      <tr>
                        <td>Model</td>
                        <td>F670L</td>
                      </tr>
                      <tr>
                        <td>GPON Port</td>
                        <td>
                          1x, SC/APC, 2,448 Gbit/s downstream 1,244 Gbit/s
                          upstream
                        </td>
                      </tr>
                      <tr>
                        <td>Subscriber interface</td>
                        <td>
                          1GE&nbsp;&amp;&nbsp;3 FE&nbsp;Port, 1x POTS, WiFi (2.4
                          GHz 802.11b/g/n 2×2, 5 GHz 802.11a/n/ac 2×2,
                          WPA/WPA2,WPS)
                        </td>
                      </tr>
                      <tr>
                        <td>Modes</td>
                        <td>Bridge, Router, AP</td>
                      </tr>
                      <tr>
                        <td>Wavelength downstream</td>
                        <td>1490nm</td>
                      </tr>
                      <tr>
                        <td>Upstream Wavelength</td>
                        <td>1310nm</td>
                      </tr>
                      <tr>
                        <td>Sensitivity</td>
                        <td>-28 dBm</td>
                      </tr>
                      <tr>
                        <td>Consumption</td>
                        <td>9 W</td>
                      </tr>
                      <tr>
                        <td>Dimensions</td>
                        <td>205 x 120 x 28 mm</td>
                      </tr>
                      <tr>
                        <td>Working temperature and humidity</td>
                        <td>0°C – 40°C, 5% – 95%</td>
                      </tr>
                      <tr>
                        <td>Power</td>
                        <td>12 IN DC</td>
                      </tr>
                      <tr>
                        <td>GPON properties</td>
                        <td>8x T-CONT, 32 GEM ports</td>
                      </tr>
                      <tr>
                        <td>Support</td>
                        <td>
                          VLAN (802.1Q, 802.1P, 802.1ad), Multicast, QoS, DHCP
                          Server/Client, NAT, IPv6 Dual Stack
                        </td>
                      </tr>
                      <tr>
                        <td>Management</td>
                        <td>Local (WEB), OMCI, TR069</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Contactform /> */}
      <Footer />
    </>
  );
};
